// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__fhmG-","content":"styles_content__8aYpw","selectAll":"styles_selectAll__2QfOp"};